import React, { useState, useEffect, Fragment } from "react";
import { bool, string } from "prop-types";
import { useDispatch, connect } from "react-redux";
import { compose } from "redux";
import withExchangeToken from "pages/_components/withExchangeToken";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Field, Form, Formik } from "formik";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";

import * as i18nUtils from "util/i18n";
// import * as configUtils from "util/config";
import { goBack, push } from "connected-react-router";

import CustomText from "pages/_components/CustomText/CustomText";
import ToDoList from "../_components/ToDoList";
import ErrorPopup from "../_components/ErrorPopup";
import Stepper from "../_components/Stepper";

const PAGE_ID = "StepUser";
const FORM_ID = "onboarding.step.user";

const StepUser = ({ isMobile, isUsernameAvailable }) => {
    const dispatch = useDispatch();
    const [isValidating, setIsValidating] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (isValidating && isUsernameAvailable && isUsernameAvailable === "USERNAME_AVAILABLE") {
            setIsValidating(false);
            dispatch(push("/onboarding/stepPassword"));
        } else if (isValidating && isUsernameAvailable && isUsernameAvailable === "USERNAME_UNAVAILABLE") {
            setIsValidating(false);
            setError(
                i18nUtils.get(
                    "onboarding.step.verifyUsername.errors.usernameUnavailable",
                    "Nombre de usuario ya utilizado, pruebe con otro.",
                ),
            );
            dispatch(modalActions.modalShow());
        } else if (isValidating && isUsernameAvailable?.length) {
            setIsValidating(false);
            setError(isUsernameAvailable);
            dispatch(modalActions.modalShow());
        }
    }, [isValidating, isUsernameAvailable]);

    const validations = [
        {
            description: i18nUtils.get("onboarding.user.validation1", "Primera letra mayúscula"),
            status: (user) => {
                if (!user) {
                    return "INITIAL";
                }
                return user[0] === user[0]?.toUpperCase() && user[0] !== user[0]?.toLowerCase() ? "DONE" : "WRONG";
            },
        },
        {
            description: i18nUtils.get("onboarding.user.validation2", "Letras y números"),
            status: (user) => {
                if (!user) {
                    return "INITIAL";
                }
                return /\d/.test(user) && /[a-zA-Z]/.test(user) ? "DONE" : "WRONG";
            },
        },
        {
            description: i18nUtils.get("onboarding.user.validation3", "Mínimo 5 caracteres"),
            status: (user) => {
                if (!user) {
                    return "INITIAL";
                }
                return user.length >= 5 ? "DONE" : "WRONG";
            },
        },
    ];

    const getItems = (user) => validations.map((val) => ({ status: val.status(user), description: val.description }));

    const submitIsDisabled = (user) => validations.some((val) => val.status(user) !== "DONE") || user.length < 5;

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: true,
        initialValues: {
            user: "",
        },
        onSubmit: ({ user }) => {
            if (user) {
                setIsValidating(true);
                dispatch(onboardingActions.setUsername(user));
            }
        },
    };

    return (
        <Fragment>
            {isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} hideNavbarInMobile />}
            <MainContainer>
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <CustomText text={i18nUtils.get("", "Elegí un usuario")} />
                </h1>
                <Formik {...formikProps}>
                    {(allFormik) => (
                        <Form className="above-the-fold">
                            <Field
                                component={TextField}
                                idForm={FORM_ID}
                                name="user"
                                labelTextDefault={i18nUtils.get("onboarding.user.label", "Usuario")}
                                placeholder={i18nUtils.get("onboarding.user.placeholder", "ej: Tuempresa22")}
                                autoFocus={!isMobile}
                                spaceEnabled={false}
                            />
                            <ToDoList items={getItems(allFormik?.values?.user)} />

                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    loading={isValidating}
                                    type="submit"
                                    block
                                    disabled={submitIsDisabled(allFormik?.values?.user)}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
            <ErrorPopup error={error} handleClick={handleClickButtonClose} />
        </Fragment>
    );
};

StepUser.propTypes = {
    isMobile: bool.isRequired,
    isUsernameAvailable: string.isRequired,
};

const mapStateToProps = (state) => ({
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    isUsernameAvailable: onboardingSelectors.getIsUsernameAvailable(state),
});
// export default connect(mapStateToProps)(StepSelectSecuritySeal);
export default compose(connect(mapStateToProps))(withExchangeToken(StepUser));
